import { z } from 'zod'

const normalizeUrl = (value: string): string => {
  const trimmed = value.trim()
  if (!trimmed) {
    return trimmed
  }
  if (/^https?:\/\//i.test(trimmed)) {
    return trimmed
  }
  return `https://${trimmed}`
}

export const onboardingWizardFormSchema = z.object({
  websiteUrl: z
    .string()
    .min(1, 'Website URL is required')
    .transform(normalizeUrl)
    .pipe(
      z
        .string()
        .url('Please enter a valid website URL')
        .refine((url) => /\.[a-z]{2,}$/i.test(new URL(url).hostname), {
          message: 'Please enter a valid domain (e.g. example.com)',
        })
    ),
})

export type OnboardingWizardFormSchemaType = z.infer<typeof onboardingWizardFormSchema>
